import styled from 'styled-components';

const FlatButton = styled.button.attrs({type: 'button'})`
  background: ${({theme}) => theme.primaryColor};
  border: 0;
  color: white;
  box-shadow: none;
  border-radius: 0;
  cursor: pointer;
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
  font-size: ${({theme}) => theme.fontMedium};
`;

export default FlatButton;
